import React from 'react'
import { CFImage, CFLink, CFView } from 'components'
import { cflogo } from 'images'

export default () => {
  return (
    <CFView column center pv="10px">
      <CFView h6 color="black" content pb="5px">
        COPYRIGHT © 2022 CODEFUSION INC.
      </CFView>
      <CFLink href="https://codefusion.tech">
        <CFImage h="20px" src={cflogo} alt="CodeFusion" />
      </CFLink>
    </CFView>
  )
}
